import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { OfferDetailsType } from './getDashOfferDetails';

const getRetsOfferDetails = async (retsId: string) => {
  const config: AxiosRequestConfig = {
    url: `/external/${retsId}/offer_details`,
    method: 'get',
  };

  const { data } = await axios.request<OfferDetailsType>(config);

  return data;
};

export default getRetsOfferDetails;
